import { Component } from '@angular/core';

@Component({
    selector: 'fc-product-empty',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.less'],
    standalone: false
})
export class ProductEmptyComponent {}
